export default {
  common: {
    cancel: 'Отказ',
    done: 'Готово',
    back: 'Назад',
    close: 'Затвори',
    start: 'Начало',
    end: 'Край',
    create: 'Създай',
    optional: 'По избор',
    loading: 'Зареждане..',
    undo: 'Отмени',
    delete: 'Изтрий',
    notes: 'Бележки',
    save: 'Запази',
    more: 'Още',
    ok: 'OK',
    errorPrefix: 'Грешка: {name}. {message}',
  },
  stop: {
    reason: {
      'out-of-stock': 'Свърши продуктът',
      'too-busy': 'Не успяваме',
      'quality-issue': 'Проблем с качеството',
      'wait-and-retry': 'Изчакайте, после пак',
      other: 'Друго',
    },
  },
  update: {
    title: 'Налична е нова версия',
    prompt: 'Да обновим ли до нова версия?',
    reload: 'Презареди',
    toastMessage: 'Нова версия: v{current} → v{latest}',
    toastMessageFallback: 'Налична е нова версия',
    statusUpToDate: 'Актуална',
    statusChecking: 'Проверка…',
    statusAvailable: 'v{latest} налична',
    checkNow: 'Провери за обновления',
    version: 'Версия на приложението',
  },
  auth: {
    authenticating: 'Удостоверяване..',
  },
  account: {
    title: 'Профил',
    printerSettings: 'Настройки на принтер',
    availablePrinters: 'Налични принтери',
    availableStorefronts: 'Налични обекти',
    selectPrinter: 'Избери принтер',
    selectStorefront: 'Избери обект',
    selectedPrinter: 'Избран принтер',
    groups: {
      settings: 'Настройки',
      account: 'Профил',
    },
    items: {
      storefront: 'Обект',
      pushNotifications: 'Push известия',
      sendTestNotification: 'Изпрати тестово известие',
      version: 'Версия',
      logOut: 'Изход',
      enabled: 'Включено',
      disabled: 'Изключено',
    },
    debugPrinter: 'Тестов принтер',
    unknownStorefront: 'Неизвестен',
    noDate: 'Без дата',
    noTime: 'Без час',
    printer: {
      title: 'Принтер и фискал',
      settings: 'Настройки',
      devMode: 'Dev режим',
      receiptPreview: 'Преглед на бележка',
      actions: 'Фискални действия',
      printDuplicate: 'Принтиране на дубликат',
      printXReport: 'Принтиране на X отчет',
      printZReport: 'Принтиране на Z отчет',
      statusLoading: 'Проверка на принтера…',
      statusNotSetUp: 'Няма избран принтер',
      statusError: 'Принтерът е недостъпен',
      confirmZ: {
        title: 'Да отпечатам ли Z отчет?',
        message: 'Този отчет може да се отпечата само веднъж. Моля, потвърди отпечатването.',
        confirm: 'Да, отпечатай',
      },
      report: {
        navRow: 'Отчет за период',
        title: 'Отчет за период',
        description:
          'Оборот по данъчни групи и ДДС за избраните дати, отпечатан на фискалния принтер.',
        from: 'От',
        to: 'До',
        mode: 'Вид отчет',
        detailed: 'Подробен',
        brief: 'Съкратен',
        withPayments: 'Разбивка по плащания',
        print: 'Отпечатай отчет',
      },
    },
  },
  shift: {
    startShift: 'Започни смяна',
    goToAccount: 'Към профила',
    current: 'Текуща смяна',
    upcoming: 'Предстояща смяна',
    greeting: 'Здравей, {name}',
    noShiftAvailable: 'Няма налична смяна',
    scheduledStarted:
      'Смяната ти беше планирана от {startTime} до {endTime}, {endDate}.',
    aboutToStart: 'Смяната ти започва скоро — {startDate} {startTime}.',
    nextWillStart:
      'Следващата ти смяна е на {startDate} в {startTime}. Може да я активираш в приложението от {activationTime}.',
  },
  dashboard: {
    title: 'Табло',
    loading: 'Зареждане на данни..',
    noData: 'Няма данни',
    groups: {
      shifts: 'Смени',
      today: 'Днес',
      inProgress: 'В процес',
    },
    items: {
      total: 'Общо',
      cash: 'В брой',
      card: 'Карта',
    },
    shiftPage: {
      fallbackTitle: 'Смяна',
      ordersGroup: 'Поръчки',
      authorizeShift: 'Заверка на смяна',
      stopShift: 'Край на смяна',
      items: 'няма позиции | {count} позиция | {count} позиции',
    },
  },
  tabs: {
    title: 'Маси',
    noOrders: 'Няма поръчки',
    unknownTabName: 'Маса без име',
  },
  inHouse: {
    orders: 'Поръчки',
    mapMove: 'Премести',
    filters: {
      byStatus: 'По статус',
      byZone: 'По зона',
      everything: 'Всички',
    },
    loadingOrders: 'Зареждане на поръчки..',
    noOrders: 'Няма намерени поръчки',
  },
  map: {
    loading: 'Зареждане на карта..',
    empty: 'Картата не е създадена',
    selectTableToMoveTo: 'Избери маса, на която да преместиш',
    moveOrderFromTo:
      'Премести поръчка от маса {fromName} на маса {toName}',
    inappropriateObject: 'Местене към/от неподходящ обект',
  },
  search: {
    productsPlaceholder: 'Търсене на продукти...',
    vendorsPlaceholder: 'Търсене на доставчици...',
  },
  products: {
    addProducts: 'Добави продукти',
    notFound: 'Няма намерени продукти',
    notAvailable: 'Няма налични продукти',
  },
  vendors: {
    changeVendor: 'Смени доставчик',
    notFound: 'Няма намерени доставчици',
    notAvailable: 'Няма налични доставчици',
  },
  procurement: {
    title: 'Доставки',
    newOrder: 'Нова поръчка',
    loadingProducts: 'Зареждане на продукти..',
    noProductsFound: 'Няма намерени продукти',
    loadingOrders: 'Зареждане на поръчки..',
    noOrdersYet: 'Все още няма поръчки',
    orderPrefix: 'Поръчка, ',
    productsCount: 'няма продукти | {count} продукт | {count} продукта',
    filters: {
      active: 'Активни',
      past: 'Минали',
    },
    status: {
      backlog: 'В списък',
      progress: 'В процес',
      arrived: 'Пристигна',
      complete: 'Готова',
    },
    item: {
      fallbackTitle: 'Позиция',
      setVendor: 'Избери доставчик',
      tapToAddPhoto: 'Натисни, за да добавиш снимка',
      warnings: 'Предупреждения',
      editAmount: 'Промени количество',
    },
    detail: {
      fallbackTitle: 'Поръчка',
      orderTitle: 'Поръчка, {date}',
      itemsCount: 'няма позиции | {count} позиция | {count} позиции',
      noProductsYet: 'Все още няма продукти',
      addProductsHint: 'Натисни +, за да добавиш продукти',
      payments: 'Плащания',
      noVendor: 'Без доставчик',
      unknownVendor: 'Неизвестен доставчик',
      unknownProduct: 'Неизвестен продукт',
      noDescription: '(без описание)',
      badges: {
        primary: 'Основен',
        alternative: 'Алтернатива',
        newSupply: 'нов supply',
        newIngredient: 'нова съставка',
      },
      pendingProduct: {
        willCreateSupply: 'Ще създаде нов supply',
        willCreateIngredient: 'Ще създаде нова съставка',
        optOutToExpense: 'Еднократно — като expense',
      },
      actions: {
        unreject: 'Възстанови',
        notReceived: 'Не получено',
        reject: 'Откажи',
        skip: 'Пропусни',
      },
      scan: {
        uploading: 'Качване на снимка…',
        parsing: 'Четене на фактура…',
        matching: 'Съпоставяне на позиции…',
        refreshing: 'Почти готово…',
        documentScanned: 'Документът е сканиран',
        createdVendor: 'Създаден доставчик: {name}',
        scanFailed: 'Сканирането неуспешно: {message}',
        matchFailed: 'Запазено, съпоставяне неуспешно: {message}',
        unknownError: 'неизвестна',
        noteSheetTitle: 'AI подсказка (по желание)',
        noteSheetHint: 'Опишете контекста, който AI трябва да използва при разчитането на документа — с най-висок приоритет.',
        notePlaceholder: 'напр. Всички "Other Item" са тениска размер L.',
        pickPhotos: 'Избери снимки',
      },
    },
  },
  transaction: {
    label: 'Транзакция #{number}',
    addCash: 'В брой',
    addCard: 'Карта',
    paid: 'Платено',
    pending: 'Чакащо',
    reversed: 'Сторнирано',
    reverse: 'Сторнирай',
    printReceipt: 'Фискална бележка',
    printPreCheck: 'Пред-бележка',
    deleteTransaction: 'Изтрий транзакция',
    printerNotConfigured: 'Принтерът не е настроен',
    printerError: 'Грешка на принтера: {response}',
    printingReceipt: 'Печатаме бележка…',
  },
  payment: {
    notFound: 'Плащането не е намерено',
    label: 'Плащане',
    save: 'Запази',
    paid: 'платено',
    pending: 'чакащо',
    date: 'Дата',
    amount: 'Сума',
    overrideAmount: 'Промени сумата',
    overrideHint: 'Персонална стойност, нужна е бележка',
    computedHint: 'Изчислено: {amount} {sign}',
    requiredPlaceholder: 'Задължително',
    overrideReasonPlaceholder: 'Защо се променя?',
    notes: 'Бележки',
    notesRequired: 'Бележки (задължително)',
    markPaid: 'Маркирай платено',
    markPending: 'Маркирай чакащо',
    methods: {
      cash: 'В брой',
      card: 'Карта',
      transfer: 'Превод',
      other: 'Друго',
    },
  },
  order: {
    noYet: 'Все още няма поръчка',
    createHint: 'Създай поръчка с натискане на бутона.',
    createButton: 'Създай поръчка',
    addMenuItem: 'Добави позиция',
    sendToWork: 'Изпрати в работа',
    checkout: 'Финализиране',
    payment: 'Плащане',
    total: 'Общо',
    paid: 'платено',
    transactions: 'Транзакции',
    noTransactionsYet: 'Все още няма транзакции',
    finalise: 'Финализирай',
    startBatch: 'Започни сесия',
    newBatch: 'Нова сесия',
    controls: 'Управление',
    notLoaded: 'Няма заредена поръчка или позиция',
    menus: 'Менюта',
    added: 'Добавено',
    toBatch: 'Към сесия',
    toMenu: 'Към меню',
    itemOnStop: 'На стоп',
    promotions: 'Промоции',
    actions: {
      addOrderToTable: 'Добави поръчка към маса',
      assignToMe: 'Възложи на мен',
      reassignTo: 'Възложи на…',
      reassignPickHeader: 'На кого да се възложи масата',
      reassignNoStaffOnShift: 'В момента няма служители на смяна',
      restoreOrder: 'Възстанови поръчка',
      cancelOrder: 'Откажи поръчка',
    },
    batchLabel: 'ПАРТИДА #{number}',
    draftBatchLabel: 'ЧЕРНОВА ПАРТИДА',
    commentAlert: {
      header: 'Въведи коментар',
      add: 'Добави',
      update: 'Обнови',
      placeholder: 'Въведи текст тук',
    },
    leaveBatchAlert: {
      header: 'Сигурен ли си?',
      message: 'В партидата има неизпратени позиции.',
      goBack: 'Назад',
    },
    errorPrefix: 'Грешка: {name}. {message}',
    addItemFailed: {
      noTax: 'Позицията не е добавена — няма зададена данъчна група за „{name}“',
      inconsistentState: 'Позицията не е добавена — непоследователно състояние на конфигуратора',
    },
    moveItems: {
      enter: 'Премести позиции',
      selectTarget: 'Избери маса',
      submit: 'Премести тук',
      submitTo: 'Премести {from} → {to}',
      cancel: 'Отказ',
      mustLeaveOne: 'Остави поне 1 позиция',
      errorNotApplied: 'Преместването не е приложено',
      errorReverted: 'Преместването е върнато',
      errorBroken: 'Преместването е счупено — позиции в двете поръчки: {ids}',
    },
    controlsPage: {
      groups: {
        status: 'Статус',
        actions: 'Действия',
      },
      markAsInProgress: 'Маркирай като „В процес“',
      markAsReady: 'Маркирай като „Готово“',
      markAsServed: 'Маркирай като „Сервирано“',
      markAsCancelled: 'Маркирай като „Отказано“',
      remove: 'Премахни',
      removeLockedInCheckout:
        'Поръчката е в процес на плащане — артикулите са заключени. Първо откажете плащането, за да промените поръчката.',
    },
  },
  tasks: {
    title: 'Задачи',
    callsTitle: 'Повиквания',
    today: 'Днес',
    loadingTasks: 'Зареждане на задачи..',
    noTasksToday: 'Няма задачи за днес',
    subtasksProgress: '{completed} от {total} подзадачи',
    allDone: 'Всичко е готово!',
    detail: {
      fallbackTitle: 'Задача',
      progress: 'Прогрес',
      subtasks: 'Подзадачи',
      verification: 'Проверка',
      reference: 'Референция',
      activation: 'Активиране',
      date: 'Дата',
      shift: 'Смяна',
      submitted: 'Подадено',
      takePhoto: 'Направи снимка',
      addComment: 'Добави коментар',
      markAsDone: 'Маркирай готова',
      undo: 'Отмени',
      noRulesMatched: 'Няма съвпаднали правила — показано като директно назначено',
      uploadFailed: 'Качването неуспешно: {message}',
      unknownError: 'Неизвестна грешка',
      status: {
        pending: 'Чакаща',
        'in-progress': 'В процес',
        completed: 'Готова',
        skipped: 'Пропусната',
        missed: 'Изпусната',
      },
      ruleTypes: {
        shiftTemplateId: 'Шаблон на смяна',
        dayOfTheWeek: 'Ден от седмицата',
        dayOfTheMonth: 'Ден от месеца',
        timeOfTheDay: 'Време от деня',
        hourOfTheDay: 'Час',
        minuteOfTheHour: 'Минута',
      },
      weekdays: {
        sun: 'Нед',
        mon: 'Пон',
        tue: 'Вто',
        wed: 'Сря',
        thu: 'Чет',
        fri: 'Пет',
        sat: 'Съб',
      },
    },
    waiterCalls: {
      noRecent: 'Няма скорошни повиквания',
      hint: 'Тук ще виждаш повикванията на сервитьор от последните 5 минути',
      noTable: 'Без маса',
      table: 'Маса',
      tableNamed: 'Маса {name}',
      noStaff: 'Без персонал',
      staffCount: '{count} души от персонала',
      calledList: 'Извикани: {names}',
      secondsAgo: 'преди {count} сек',
      minutesAgo: 'преди {count} мин',
    },
  },
  promotions: {
    sidebarTitle: 'Приложени промоции',
    contentTitle: 'Добави промоция',
    sidebarPlaceholder: 'Добавяй промоции отдясно',
    remove: 'Премахни',
    done: 'Готово',
    searchInputPlaceholder: 'Започни да въвеждаш',
    searchCancel: 'Отказ',
    searchPlaceholder: 'Започни да въвеждаш и тук ще се покажат резултати.',
    matchingPromotions: 'Подходящи промоции',
    apply: 'Приложи',
    applied: 'Приложено',
  },
}
